import axios from "axios";
import { toast } from "react-toastify";

import { RoutingRule } from "./RoutingRule";
import { mapApiCategory } from "../categories/categoriesApi";
import { mapApiLocation } from "../locations/locationsSlice";

export const ROUTING_RULES_API_URL = `${process.env.REACT_APP_API_BASE_URL}/routingRules`;

export const fetchRoutingRules = async () => {
  try {
    const response = await axios.get(ROUTING_RULES_API_URL);
    const routingRules: RoutingRule[] = response.data.map(mapApiRoutingRule);
    return routingRules;
  } catch (err) {
    return [];
  }
};

export const createRoutingRule = async (routingRule: RoutingRule) => {
  const response = await axios.post(ROUTING_RULES_API_URL, routingRule);
  const newRoutingRule = mapApiRoutingRule(response.data);
  toast.success("Regula de rutare a fost creata cu succes!");
  return newRoutingRule;
};

export const updateRoutingRule = async (routingRule: RoutingRule) => {
  await axios.put(ROUTING_RULES_API_URL, routingRule);
  toast.success("Regula de rutare a fost actualizata cu succes!");
};

export const updateRoutingRulesOrder = async (routingRules: RoutingRule[]) => {
  const payload = routingRules.map((routingRule, index) => ({ id: routingRule.id, executionOrder: index + 1 }));
  await axios.put(`${ROUTING_RULES_API_URL}/executionOrder`, payload);
  toast.success("Ordinea regulilor de rutare a fost actualizata cu succes!");
};

export const deleteRoutingRule = async (routingRule: RoutingRule) => {
  await axios.delete(`${ROUTING_RULES_API_URL}/${routingRule.id}`);
  toast.success("Regula de rutare a fost stearsa cu succes!");
};

export const mapApiRoutingRule = (apiRoutingRule: any): RoutingRule => ({
  id: `${apiRoutingRule.id}`,
  name: apiRoutingRule.name,
  executionOrder: apiRoutingRule.executionOrder,
  departmentId: `${apiRoutingRule.departmentId}`,
  isActive: apiRoutingRule.isActive,
  locations: (apiRoutingRule.locations ?? []).map(mapApiLocation),
  ticketType: apiRoutingRule.ticketType,
  categories: (apiRoutingRule.categories ?? []).map(mapApiCategory),
  teamId: `${apiRoutingRule.teamId}`,
  teamName: apiRoutingRule.teamName,
});
